module.exports = __webpack_public_path__ + "img/contentBox1_info_img3.b0bacda1.png";